import iebtLogoAsset from '../assets/images/defaults/iebtLogo.png'

export const DEFAULT_SIDEBAR_LOGO = iebtLogoAsset
